import React, { useEffect, useState } from 'react';
import TrainingService from '../../Service/TrainingService';

const TrainingMaintien = ({ training }) => {
    const [editMode, setEditMode] = useState(false);
    const [textAreaValue, setTextAreaValue] = useState('');
    const token = sessionStorage.getItem('token');

    // Convert HTML to plain text for editing
    useEffect(() => {
        if (training.thematique) {
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = training.thematique;  // Initial value in HTML
            setTextAreaValue(tempDiv.innerText);  // Convert HTML to plain text for editing
        }
    }, [training.thematique]);

    const handleEditClick = () => {
        setEditMode(true);
    };

    const handleInputChange = (event) => {
        setTextAreaValue(event.target.value);
    };

    const handleSaveClick = async () => {
        // Save the modified text to the training object
        training.thematique = textAreaValue;  // Modified text is in plain text

        try {
            let response;
            if (training.modif) {
                response = await TrainingService.putModifTraining(training);
            } else {
                response = await TrainingService.postModifTraining(training);
            }
            window.location.reload();
            console.log(response);
        } catch (error) {
            console.log("Error: " + error);
        }
        setEditMode(false);
    };

    return (
        <div className="section-content">
            {editMode ? (
                // Edit mode: display textarea for modifying the content
                <textarea
                    value={textAreaValue}
                    onChange={handleInputChange}
                    rows={10}
                    style={{ width: '100%' }}
                />
            ) : (
                // Display mode: show the content or placeholder text
                <div style={{ whiteSpace: 'pre-wrap' }}>
                    {training.thematique ? (
                        <div dangerouslySetInnerHTML={{ __html: training.thematique }} />
                    ) : (
                        <p>Un recyclage est obligatoire tous les 36 mois (3 ans), avec l'obligation de justifier de 1 607 heures d'activité sur cette période</p>
                    )}
                </div>
            )}
            {editMode ? (
                <button
                    className="inscription-button modif_button"
                    onClick={handleSaveClick}
                    style={{ right: 0 }}
                >
                    Enregistrer
                </button>
            ) : (
                token === '' && (
                    <button
                        className="inscription-button modif_button"
                        onClick={handleEditClick}
                        style={{ marginLeft: '10px' }}
                    >
                        Modifier
                    </button>
                )
            )}
        </div>
    );
};

export default TrainingMaintien;